import React from "react";

const ChatSkeleton = () => {
  return (
    <div className="animate-pulse w-full p-5">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="flex flex-col gap-4 w-[20%]">
              <div className="h-10 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-screen bg-DarkBlue-700 rounded-md "></div>
            </div>
            <div className=" flex flex-col gap-4 w-[70%]">
              <div className="h-10 flex justify-end">
                <div className=" bg-DarkBlue-700 rounded-md  w-1/5" />
              </div>
              <div className="h-20 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-10 flex justify-start">
                <div className=" bg-DarkBlue-700 rounded-md  w-2/5" />
              </div>
              <div className="h-10 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-10 flex justify-end">
                <div className=" bg-DarkBlue-700 rounded-md  w-4/5" />
              </div>
              <div className="h-20 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-10 flex justify-start">
                <div className=" bg-DarkBlue-700 rounded-md  w-1/5" />
              </div>
              <div className="h-10 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-10 flex justify-end">
                <div className=" bg-DarkBlue-700 rounded-md  w-4/5" />
              </div>
              <div className="h-30 bg-DarkBlue-700 rounded-md "></div>
              <div className="h-10 flex justify-start">
                <div className=" bg-DarkBlue-700 rounded-md  w-1/5" />
              </div>
              <div className="h-10 bg-DarkBlue-700 rounded-md "></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSkeleton;
